<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="hidden lg:block flex-none">
      <h5 class="text-sm font-medium text-gray-600 mb-2">Menu</h5>
    </div>
    <div class="hidden lg:block flex-1 lg:h-0">
      <div class="h-full overflow-auto fancy-scrollbar">
        <div>
          <ul class="select-none">
            <li
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'DetailsTab'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('DetailsTab')"
            >
              Details
            </li>
            <li
              v-if="$membershipHasPermissionTo('read tasks')"
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Activity'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Activity')"
            >
              Tasks
            </li>
            <li
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Notes'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Notes')"
            >
              Notes
            </li>
            <li
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Tags'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Tags')"
            >
              Tags
            </li>
            <li
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Attachments'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Attachments')"
            >
              Attachments
            </li>
            <li
              v-if="$isAdminOrSuperAdmin"
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Offers'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Offers')"
            >
              Offers
            </li>
            <li
              v-if="$membershipHasPermissionTo('read sms messages,read email messages')"
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'Messages'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('Messages')"
            >
              Messages
            </li>
            <li
              v-if="$isAdminOrSuperAdmin"
              class="px-4 py-2 rounded mt-2"
              :class="[
                currentTab === 'ConversationManager'
                  ? 'bg-blue-700 text-white'
                  : 'hover:bg-blue-300 hover:text-blue-900',
              ]"
              @click="setCurrentTab('ConversationManager')"
            >
              Conversation
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-none mt-4">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactMenu',

  props: {
    currentTab: {
      type: String,
      default: '',
    },
  },

  methods: {
    setCurrentTab(name) {
      this.$emit('change', name);
    },
  },
};
</script>
